import MultiSelector from "../../components/MultiSelector.js";
import React, { useState, useEffect } from "react";

export default function FetchMultiSelector({ passData }) {
  const [AirportNames, setAirportNames] = useState([]);

  useEffect(() => {
    var url = "/api/airportnames";

    fetch(url)
      .then((res) =>
        res.json().then((res) => {
          console.log(res);
          const newList = [];

          // console.log("here",res.data["airport_names"])

          //In order to get data to the specific format {key : Αερολιμενας ΑΘηνων ATH}
          for (const [key, value] of Object.entries(
            res.data["airport_names"]
          )) {
            // console.log("key", key)
            // console.log("value", value)
            const newItem = { key: `${value} ${key}` };
            newList.push(newItem);
          }

          console.log("names", newList);
          setAirportNames(newList);
        })
      )
      .catch((error) => {
        console.log("Refetching data for Airport Names!");
      });
  }, []);

  let AirportSelectorOprions = {
    title: "",
    default_text: "Επίλεξε αεροδρόμιο",
    options: AirportNames,
  };

  return (
    <MultiSelector
      passData={passData}
      props={AirportSelectorOprions}
    ></MultiSelector>
  );
}
